// import { useUser } from '@auth0/nextjs-auth0/client';
import { FC, ReactElement } from 'react';

// import useHeaderState from '@/utils/hooks/useHeaderState';
import ToggleButton from './ToggleButton';

const ToggleContent: FC = (): ReactElement => {
	// const { user } = useUser();
	// const { showBackground } = useHeaderState();

	return (
		<div className="flex flex-row items-center">
			{/* {!user && (
        <div className="flex flex-row items-center">
          <AnimatedNextLink
            href={PATHS.AUTH.LOGIN}
            className={`mr-6 hidden text-sm font-medium md:flex ${
              showBackground ? 'text-midnight dark:text-white' : 'text-midnight dark:text-white'
            }`}
            prefetch={false}>
            LOG IN
          </AnimatedNextLink>
          <CustomButtonLink
            className={`h-auto bg-[linear-gradient(162deg,#DD1438_0%,#E42A6D_100%)] px-4 py-2 text-sm font-medium text-white dark:bg-[linear-gradient(162deg,#DD1438_0%,#5B01A2_100%)] ${
              !showBackground ? '' : 'before:to-1.04% before:from-100.92% z-50 hover:text-white'
            }`}
            href={PATHS.AUTH.SIGNUP}
            useNextLink={false}>
            Sign Up
          </CustomButtonLink>
        </div>
      )} */}
			<div className="relative">
				<ToggleButton />
			</div>
		</div>
	);
};

export default ToggleContent;
